import styled from 'styled-components/macro';

const FooterWrapper = styled.div`
  height: 50px;
  width: 100%;
  background-color: #FEFCFB;
`;

function Footer() {
  return (
    <FooterWrapper />
  );
}
export default Footer;
